module.exports = __webpack_public_path__ + "static/media/js.33e38ae9.png";